<div class="sections-list" [class.rtl]="currLang == 'ar'">
  <div *ngIf="loading" class="loading">
    <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
  </div>
  <div class="content" *ngIf="sections.length > 0 || (sections.length == 0 && searchText?.length > 0 )">
    <div class="header-wrapper">
      <div class="control-bar">
        <app-control-bar [listType]="listType"></app-control-bar>
      </div>
      <div class="add-new">
        <button class="add-new-btn" (click)="addSection()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 3.75V16.25M16.25 10H3.75" stroke="white" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span> {{'school-management.sections.add-btn' | translate}} </span>
        </button>
      </div>
    </div>
    <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)" [showSideBar]="false"></app-table-view>
  </div>

  <div *ngIf="sections.length == 0 && searchText?.length == 0" class="no-sections">
    <svg width="164" height="165" viewBox="0 0 164 105" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M131.257 44.1523H36.1662C32.5019 44.1523 29.532 47.0852 29.532 50.7037V63.8063H131.257V44.1523Z"
        fill="#A5BBD7" />
      <path
        d="M131.257 40.4683C131.257 36.8498 128.287 33.917 124.623 33.917C115.271 33.917 98.4112 33.917 89.9503 33.917C86.7769 33.917 83.8446 35.5963 82.27 38.3173C79.6584 42.8334 75.9719 49.2034 75.9719 49.2034H131.257V40.4683Z"
        fill="#A5BBD7" />
      <path d="M29.532 50.291H131.257V54.3594H29.532V50.291Z" fill="#8DA3BE" />
      <path
        d="M138.705 62.8983C139.057 60.3957 138.294 57.8647 136.616 55.9605C134.935 54.054 132.502 52.96 129.944 52.96C107.396 52.96 53.3933 52.96 30.8456 52.96C28.287 52.96 25.8545 54.054 24.1738 55.9605C22.4953 57.8647 21.7324 60.3957 22.084 62.8983C24.3264 78.8399 28.6784 109.78 30.6842 124.044C31.2923 128.361 35.0296 131.576 39.4459 131.576H121.344C125.76 131.576 129.497 128.361 130.105 124.044C132.111 109.78 136.463 78.8399 138.705 62.8983Z"
        fill="#CADCF0" />
      <path
        d="M22.827 68.1831C22.9929 66.364 23.7315 64.6257 24.9677 63.2237C26.6462 61.3195 29.0787 60.2254 31.6373 60.2254H129.152C131.711 60.2254 134.143 61.3195 135.822 63.2237C137.058 64.6257 137.797 66.364 137.962 68.1831L138.705 62.8983C139.057 60.3957 138.294 57.8647 136.616 55.9605C134.935 54.054 132.502 52.96 129.944 52.96C107.396 52.96 53.3933 52.96 30.8456 52.96C28.287 52.96 25.8545 54.054 24.1738 55.9605C22.4953 57.8647 21.7324 60.3957 22.084 62.8983L22.827 68.1831Z"
        fill="#E9F3FC" />
      <path
        d="M70.4456 109.795C70.4456 107.384 68.4664 105.428 66.0228 105.428C61.1156 105.428 53.2408 105.428 48.3314 105.428C45.89 105.428 43.9086 107.384 43.9086 109.795V114.163C43.9086 116.576 45.89 118.53 48.3314 118.53H66.0228C68.4664 118.53 70.4456 116.576 70.4456 114.163C70.4456 112.759 70.4456 111.202 70.4456 109.795Z"
        fill="#405267" />
      <path
        d="M103.615 68.7705C90.7994 68.7705 80.3947 79.0452 80.3947 91.7002C80.3947 104.355 90.7994 114.63 103.615 114.63C116.43 114.63 126.834 104.355 126.834 91.7002C126.834 79.0452 116.43 68.7705 103.615 68.7705ZM103.615 75.3218C112.768 75.3218 120.2 82.6615 120.2 91.7002C120.2 100.739 112.768 108.079 103.615 108.079C94.4615 108.079 87.0289 100.739 87.0289 91.7002C87.0289 82.6615 94.4615 75.3218 103.615 75.3218Z"
        fill="#405267" />
      <path
        d="M115.709 107.535L136.337 127.906C137.633 129.185 139.734 129.185 141.03 127.906C142.323 126.628 142.323 124.551 141.03 123.274L120.402 102.903C119.106 101.626 117.005 101.626 115.709 102.903C114.415 104.181 114.415 106.258 115.709 107.535Z"
        fill="#405267" />
    </svg>
    <div class="no-sections-title">
      {{'school-management.sections.no-sections.title' | translate}}
    </div>
    <div class="no-sections-desc">
      {{'school-management.sections.no-sections.desc1' | translate}}
      <br>
      {{'school-management.sections.no-sections.desc2' | translate}}
    </div>
    <div class="add-new">
      <button class="add-new-btn" (click)="addSection()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 3.75V16.25M16.25 10H3.75" stroke="white" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span> {{'school-management.sections.add-btn' | translate}} </span>
      </button>
    </div>
  </div>
</div>
<div class="back-drop" *ngIf="showDeleteModalFlag">
  <div class="modal-container" style="height: fit-content;">
    <div class="modal-head">
      <div class="title"> {{'school-management.sections.delete-section-modal.title' | translate}} </div>
    </div>
    <div class="modal-bady">
      <div class="desc">
        {{'school-management.sections.delete-section-modal.desc' | translate}}
      </div>
    </div>
    <div class="modal-footar">
      <button class="cancel" (click)="closeDeleteModal()">
        {{'school-management.sections.delete-section-modal.cancel-btn' | translate}}
      </button>
      <button class="delete" (click)="deleteSection()">
        {{'school-management.sections.delete-section-modal.del-btn' | translate}}
      </button>
    </div>
  </div>
</div>
<app-error-msg></app-error-msg>